import { Box, colors, styled, TableCell, tableCellClasses, TableRow } from "@mui/material";

export const PrimaryButton = (colors) => ({
  backgroundColor: colors.primary[400],
  padding: "8px",
  paddingX: "16px",
  borderRadius: "8px",
  color: "white",
  textTransform: "none",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  transition: "all 0.2s ease-in-out",
  '&:hover': {
    backgroundColor: colors.primary[300],
  },
  '&:disabled': {
    backgroundColor: colors.grey[200],
    color: colors.grey[500]
  }
});

export const SecondaryButton = (colors) => ({
  backgroundColor: colors.secondary[400],
  padding: "5px",
  paddingX: "15px",
  borderRadius: "9px",
  boxShadow: "none",
  color: colors.secondary[20],
  '&:hover': {
    backgroundColor: colors.secondary[700],
  },
  '&:disabled': {
    backgroundColor: colors.grey[20],
    color: colors.grey[500]
  }
});


export const SecondaryOutlinedButton = (colors) => ({
  padding: "8px",
  paddingX: "16px",
  borderRadius: "8px",
  boxShadow: "none",
  color: colors.primary[400],
  border: `1px solid ${colors.primary[400]}`,
  textTransform: "none",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  transition: "all 0.2s ease-in-out",
  '&:hover': {
    backgroundColor: colors.grey[200],
  },
  '&:disabled': {
    backgroundColor: colors.grey[20],
    color: colors.grey[500]
  }
});



export const CardContainer = (theme) => ({
  padding: "8px",
  borderRadius: '10px',
  //only border for light mode 
  border: theme.palette.mode === 'light' ? `1px solid ${theme.palette.grey[400]}` : 'none',
  width: "100%",
  height: "100%",
  minWidth: '310px',
  boxShadow: theme.palette.mode === 'light' ? "-1px 2px 6px -4px rgba(0,0,0,0.75)" : 'none',
  backgroundColor: theme.palette.background.card,
});

// -----------card
export const TitleCard = (colors) => ({
  fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.3rem", lg: "1.5rem", xl: "1.5rem" },
  color: colors.primary[800],
  fontFamily: "Nunito Sans",
  fontWeight: "500"
});

export const SubTitleCard = (colors) => ({
  fontSize: { xs: "0.9rem", sm: "0.9rem", md: "1rem", lg: "1rem", xl: "1rem" },
  color: colors.grey[600],
  fontFamily: "Nunito Sans",
});






// Select-----------

//---------------- table x grid data
export const tableStyle = (colors) => ({
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${colors.grey[200]}`,
    color: colors.grey[700],
    fontSize: '14px',
  },
  '& .MuiDataGrid-columnHeaders': {
    color: colors.grey[800],
    fontSize: '16px',
    fontFamily: 'Nunito Sans',
    backgroundColor: colors.grey[100],
    borderBottom: `1px solid ${colors.grey[200]}`,
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: '700 !important',
    }
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    justifyContent: 'flex-start',
  },
  '& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]': {
    background: 'transparent',
  },
})


//------------------ table style react table
export const StyledTableCell = styled(TableCell)(({ theme, colors }) => ({

  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: colors.grey[700],
  },
  [`&.${tableCellClasses.root}`]: {
    padding: "5px 16px"
  },
}));
export const StyledHeadCell = styled(TableCell)(({ theme, colors }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 15,

    color:colors.grey[700],
    fontWeight: "bold",
    fontFamily: "Nunito Sans",
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  [`&.${tableCellClasses.root}`]: {
    padding: "12px 16px",

  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,

  // '&:nth-of-type(odd)': {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  // '&:last-child td, &:last-child th': {
  //   border: 0,
  // },
}));


export const StyledTableRowHead = styled(TableRow)(({ theme,colors }) => ({
  border: `1px solid ${theme.palette.divider}`,
  // backgroundColor: colors.primary[20],
  borderTopLeftRadius: "80px", // Match the radius
  borderTopRightRadius: "80px", // Match the radius
  overflow: "hidden", // Ensures no clipping issues
  

}));

export const StyledSortIcon = styled(Box)(({ theme }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '4px',
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
    opacity: 0.5,
  }
}));

//----------------------------- File Upload Styles
export const FileUploadStyles = (colors) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  dropZone: {
    padding: 3,
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: 'background.paper',
    border: `3px dashed ${colors.primary[100]}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    minHeight: '200px',
    justifyContent: 'center',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary[50],
      opacity: 0.6
    }
  },
  dropZoneActive: {
    backgroundColor: colors.primary[400],
    opacity: 0.3,
    border: `2px dashed ${colors.primary[400]}`
  },
  uploadButton: {
    width: 'fit-content',
    backgroundColor: colors.primary[400],
    '&:hover': {
      backgroundColor: colors.primary[300]
    }
  },
  hiddenInput: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  }
});
//-----------------------------dialog styles
export const IconContainer = (colors) => ({
  // backgroundColor: colors.primary[20],
  // borderRadius: '15px',
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.primary[800],

});

export const DialogTitleText = (colors) => ({
  fontSize: 20,
  color: colors.primary[800],
  fontFamily: "Nunito Sans",
  fontWeight: "600"
});

export const DialogSection = (colors) => ({
  fontSize: "1.1rem",
  color: colors.grey[500],
  fontFamily: "Nunito Sans",
  mb: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  fontWeight: "bold"
});

export const DialogSectionLabel = (colors) => ({
  fontSize: "0.9rem",
  color: colors.grey[700],
  fontFamily: "Nunito Sans",
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,  // Reduced gap between icon and label
  minWidth: 'auto',  // Remove fixed width to let content determine width
  marginRight: '8px',  // Add small space after label
  fontWeight: "bold"
});
export const DialogSectionValue = (colors) => ({
  fontSize: "0.9rem",
  color: colors.grey[600],
});

export const DialogPrimaryButton = (colors) => ({
  backgroundColor: colors.primary[400],
  padding: "8px",
  paddingX: "16px",
  borderRadius: "8px",
  color: "white",
  textTransform: "none",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  transition: "all 0.2s ease-in-out",
  '&:hover': {
    backgroundColor: colors.primary[300],
  },
  '&:disabled': {
    backgroundColor: colors.grey[200],
    color: colors.grey[500]
  }
});

export const DialogSecondaryButton = (colors) => ({
  padding: "5px",
  paddingX: "15px",
  borderRadius: "6px",
  boxShadow: "none",
  color: colors.primary[600],
  '&:hover': {
    backgroundColor: colors.primary[20],
  },
  '&:disabled': {
    backgroundColor: colors.grey[20],
    color: colors.grey[500]
  }
});







// Add new tab styles
export const TabStyles = {
  minHeight: '50px',
  padding: '8px 16px',
};

export const TabsContainer = {
  borderBottom: 1, 
  borderColor: 'divider', 
  mb: 2
};

export const SubscriptionHistoryStyles = (colors) => ({
  listItem: {
    marginBottom: 1,
    backgroundColor: colors.grey[70],
    borderRadius: 1,
  },
  avatar: {
    active: {
      bgcolor: colors.green[500]
    },
    inactive: {
      bgcolor: colors.grey[500]
    }
  },
  contentBox: {
    flexGrow: 1
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    marginBottom: 1
  },
  dateBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    color: colors.grey[500]
  },
  priceBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginLeft: 2
  }
});

// Select-----------
export const SelectLabel = (colors) => ({
  '& .MuiInputBase-input': {
    backgroundColor: colors.grey[60],
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    fontSize: "1.1rem",
    fontWeight: "600",
  },
  ' & .MuiInputLabel-outlined.MuiInputLabel-shrink ': {
    transform: 'translate(12px, -10px) scale(0.75)'
  },
  '& fieldset': {
    fontSize: '1.1rem',

  },
} );


// ----------------screen
export const AccordionStyle = (colors) => ({
  fontSize: { xs: "1.5rem"},
  color: colors.primary[800],
  fontFamily: "Ancizar Sans",
  fontWeight: "600",

});
export const TitleScreen = (colors) => ({
  fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.5rem", lg: "1.6rem", xl: "1.6rem" },
  color: colors.primary[700], 
  fontFamily: "Nunito Sans, Ancizar Sans, sans-serif",
  fontWeight: "700",
  marginBottom: "8px",
  letterSpacing: "0.3px",
  lineHeight: 1.2
});

export const SubTitleScreen = (colors) => ({
  fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem", lg: "1.05rem", xl: "1.1rem" },
  color: colors.grey[600],
  fontFamily: "Nunito Sans, sans-serif",
  fontWeight: "400",
  mb: "16px",
  maxWidth: "600px",
  lineHeight: 1.4,
  letterSpacing: "0.2px"
});
export const TextStyle = (colors) => ({
  fontSize: "1.2rem" ,
  color: colors.grey[800],
  fontFamily: "Nunito Sans",
  fontWeight: "400",
  mb: 1,
});
export const LabelText = (colors) => ({
  fontSize: "1rem",
  color: colors.grey[600],
  fontFamily: "Nunito Sans",
  fontWeight: "500",
  mb: 1,
});

export const OutlinedInputStyle = (colors) => ({
  backgroundColor: colors && colors.grey && colors.grey[60] ? colors.grey[60] : 'transparent',

 '& .MuiSelect-select': {
  padding: '12px 4px',
}
});


// ------------textfield
export const FieldLabel = (colors) => ({

  backgroundColor: colors && colors.grey && colors.grey[60] ? colors.grey[60] : 'transparent',

  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    fontSize: '1.1rem',
    fontWeight: 600,
    transform: 'translate(12px, -10px) scale(0.75)', // Merged duplicate selectors
  },
  '& fieldset': {
    fontSize: '1.1rem',
  },

  '& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '12px 16px',
  },
  //for search zone 
  '& .css-qve9l1-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '12px 16px',
  },
  '& .css-j3jqhj-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '12px 16px',
  },

});

export const Text = (colors) => ({
  color: colors.grey[700],
  fontFamily: "Nunito Sans",
})


// ----------------screen
export const SectionTitle = (colors) => ({
  fontSize: { xs: "2rem", sm: "2.3rem", md: "2.4rem", lg: "2.5rem", xl: "2.5rem" },
  color: colors.primary[800],
  fontFamily: "Ancizar Sans",
  fontWeight: "800",
});

export const SectionText = (colors) => ({
  fontSize: "1.4rem",
  color: colors.grey[700],
  fontFamily: "Nunito Sans",
  fontWeight: "600",
});

// SkillCard styles
export const SkillCardStyles = (colors) => ({
  card: {
    borderRadius: "8px",
    border: `1px solid ${colors.Orange[400]}`,
    padding: "20px",
    position: "relative",
    overflow: "hidden",
    backgroundColor: colors.primary[400],
    maxWidth: "450px",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 4px 10px ${colors.Orange[100]}`,
    },
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
  },
  categoryChip: {
    backgroundColor: colors.grey[200],
    color: colors.grey[800],
    fontWeight: 500,
    fontSize: "0.7rem",
  },
  priorityChip: {
    color: "white",
    fontWeight: 500,
    fontSize: "0.7rem",
  },
  cardActions: {
    display: "flex",
    gap: 1,
  },
  actionIcon: {
    fontSize: "1.1rem",
    color: colors.grey[650],
    cursor: "pointer",
    transition: "color 0.2s",
    "&:hover": {
      color: colors.primary[500],
    },
  },
  cardTitle: {
    fontWeight: "bold",
    color: colors.grey[800],
    marginTop: 1,
    marginBottom: 0.5,
  },
  skillCode: {
    color: colors.primary[500],
    fontWeight: 500,
    fontSize: "0.85rem",
    marginBottom: 1.5,
  },
  cardDescription: {
    color: colors.grey[650],
    fontSize: "0.9rem",
    marginBottom: 2,
    lineHeight: 1.4,
  },
  levelContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 0.5,
  },
  levelText: {
    color: colors.grey[650],
    fontSize: "0.8rem",
  },
  levelValue: {
    color: colors.grey[800],
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  progressBarContainer: {
    width: "100%",
    height: "6px",
    backgroundColor: colors.grey[200],
    borderRadius: "10px",
    overflow: "hidden",
    marginBottom: 2,
  },
  progressBar: {
    height: "100%",
    borderRadius: "10px",
  },
  cardFooter: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  commentText: {
    color: colors.grey[650],
    fontSize: "0.75rem",
    fontStyle: "italic",
  },
  referenceContainer: {
    display: "flex",
    gap: 2,
    marginTop: 1,
  },
  referenceLink: {
    color: colors.Blue[400],
    fontSize: "0.75rem",
    cursor: "pointer",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    "&:hover": {
      textDecoration: "underline",
    },
  },
});